/*
 * LEDS.ro filter ranges (snippets/leds-filter-buckets.liquid): ticking a range ticks the hidden filter values it
 * groups, then fires one change event on them so Warehouse reloads the products with all those values (OR).
 */
(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var bucket = event.target;
    if (!bucket.hasAttribute || !bucket.hasAttribute('data-leds-bucket')) return;

    var item = bucket.closest('.leds-bucket');
    var values = item ? item.querySelectorAll('[data-leds-bucket-value]') : [];
    if (!values.length) return;

    Array.prototype.forEach.call(values, function (input) {
      input.checked = bucket.checked;
    });

    values[0].dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
